export function buildStandardHeaders(le, uiProfile) {

    const headers = [
        { label: le.stock.list.captions[0], field: "SKU", className: "cell-center", size: 1 },
        { label: le.stock.list.captions[1], field: "description", className: "cell-description", size: 2 },
        { label: le.stock.list.captions[2], field: "avaibleQuantity", className: "cell-center", size: 1 },
        { label: le.stock.list.captions[3], field: "reservedQuantity", className: "cell-center", size: 1 },
        { label: le.stock.list.captions[4], field: "serialCode", className: "cell-center", size: 2 },
        { label: le.stock.list.captions[5], field: "SORD", className: "cell-center", size: 2 },
        { label: le.stock.list.captions[6], field: "BCNU", className: "cell-center", size: 2 },
        { label: le.stock.list.captions[7], field: "SCNU", className: "cell-center", size: 2 },
        { label: le.stock.list.captions[8], field: "ownerCode", className: "cell-center", size: 2 },
        { label: le.stock.list.captions[9], field: "CNUM", className: "cell-center", size: 2 },
    ]

    if (uiProfile.showDealerColumn) {
        headers.push(
            {
                label: le.stock.list.captions[10],
                field: "dealerName",
                className: "cell-center",
                size: 3
            },
            {
                label: le.stock.list.captions[11],
                field: "dealerCode",
                className: "cell-center",
                size: 2
            }
        );
    }

    return headers;

}